// extracted by mini-css-extract-plugin
module.exports = {"menuLabel":"MainMenu_menuLabel__3ymAW","menuList":"MainMenu_menuList__L0PRx","menuItem":"MainMenu_menuItem__38N5U","active":"MainMenu_active__17_hn"};